import React, { useState, useEffect } from 'react';
import { Star, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const TipOfDay = () => {
  const [tip, setTip] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/^http:\/\//i, 'https://');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/tip-of-day/`);
        const data = await res.json();
        if (data.tip_id) setTip(data);
      } catch { /* ignore */ }
      setLoading(false);
    })();
  }, []);

  if (loading || !tip) return null;

  return (
    <div
      className="mb-8 p-5 bg-gradient-to-r from-[#1E1E1E] to-[#2A1E2E] border border-[#7B1FA2]/40 rounded-xl"
      data-testid="tip-of-day"
    >
      <div className="flex items-center gap-2 mb-3">
        <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
        <span className="text-sm font-bold text-yellow-400 uppercase tracking-wide">Tipp des Tages</span>
      </div>
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <div className="text-lg font-bold">
            {tip.team_home} <span className="text-gray-500 text-sm">vs</span> {tip.team_away}
          </div>
          <div className="text-sm text-gray-400">
            {tip.sport} &middot; {tip.league}
          </div>
        </div>
        <div className="text-right">
          <div className="font-mono text-2xl font-bold text-[#00BFA6]">{tip.confidence}%</div>
          <div className="text-xs text-gray-500">Vertrauen</div>
        </div>
      </div>
      <div className="mt-3 text-sm text-gray-400">
        Vorhersage: <span className="text-white font-medium">{tip.prediction_teaser}</span>{' '}
        <Button
          variant="link"
          className="text-[#00BFA6] p-0 h-auto text-sm"
          onClick={() => navigate('/pricing')}
          data-testid="tip-of-day-unlock"
        >
          Jetzt freischalten <ArrowRight className="w-3 h-3 ml-1 inline" />
        </Button>
      </div>
    </div>
  );
};

export default TipOfDay;
